import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import styled from "styled-components";
import { AppRemixIcon, AppCheckbox, AppSingleSelect } from "@/layout/AppComponents";
import colors from "../../../../constants/colors";
import Translator from "../../../components/helpers/Translator";
import _ from "lodash";

export default function UserManagementEditModuleCard({
    module,
    values,
    setFieldValue,
}) {
    const { moduleBridgeHex } = useParams();
    const auth = useSelector((state) => state.auth);
    const modulePermissions = useSelector(
        (s) => s.module[moduleBridgeHex]?.permissions,
    );
    const templateOptions = useSelector((s) => s.currentPage?.permissionTemplates);

    const renderPermissionSelect = useCallback(() => {
        switch (module?.type) {
            case "DocumentManager":
            case "TotalEnergiesRisk":
                return (
                    <div style={{ marginLeft: "auto", minWidth: "300px" }}>
                        <AppSingleSelect
                            title="Nivel de permiso"
                            options={module?.permissionsLevels}
                            placeholder={module?.permissionsLevels?.[0]?.label}
                            value={
                                values?.editModules?.[module.hex]?.permissionLevel ??
                                module?.permissionLevel
                            }
                            onChange={(opt) =>
                                setFieldValue(`editModules[${module.hex}].permissionLevel`, opt)
                            }
                        />
                    </div>
                );
            case "LegalCompliance":
                return (
                    <>
                        {templateOptions?.length > 0 && modulePermissions?.userManagement?.permissionTemplates &&
                            modulePermissions?.permissionTemplates !== false && (
                                <PermissionTemplateWrapper>
                                    <AppSingleSelect
                                        icon={<AppRemixIcon icon="apps-2" />}
                                        options={templateOptions || []}
                                        title={ReactDOMServer.renderToString(
                                            <Translator
                                                file="module-userManagement"
                                                name="general.permission.templates"
                                            />,
                                        )}
                                        value={values?.editModules?.[module.hex]?.template}
                                        onChange={(opt) =>
                                            setFieldValue(`editModules[${module.hex}].template`, opt)
                                        }
                                        isClearable
                                    />
                                </PermissionTemplateWrapper>
                            )}
                    </>
                );
            default:
                return null;
        }
    }, [module, values, setFieldValue, modulePermissions, templateOptions]);

    const handleSelectDeletePlant = useCallback((valuesDeletePlants, plantHex) => {
        const valuesDelete = [...valuesDeletePlants];

        if (valuesDelete.includes(plantHex)) {
            return valuesDelete.filter((v) => v != plantHex);
        } else {
            valuesDelete.push(plantHex);
            return valuesDelete;
        }
    }, []);

    return (
        <div className="card border mt-2">
            <div className={`${module.type === "LegalCompliance" ? "bg-light" : ""} p-1`}>
                <div className="ml-2 mr-2 d-flex align-items-center">
                    <span className="mr-2">
                        <img
                            src={module.image !== null ? module.image : auth.user.client.logoUrl}
                            // src="https://worldlex.net/assets/images/modules/cards/gcl.png"
                            className="img-responsive"
                            style={{ height: "30px" }}
                        />
                    </span>
                    <span
                        className={`ml-1 ${module.isDisabled ? "text-light" : "text-primary"}`}
                    >
                        {module.name}
                    </span>
                    {renderPermissionSelect()}
                </div>

                {module.type === "LegalCompliance" && (
                    <div className="ml-4 mr-4">
                        {module.plants?.map((plant, i) => (
                            <div className="p-2" key={plant.hex}>
                                <div
                                    className={`${values.deletePlants.includes(plant.hex)
                                            ? "alert-danger"
                                            : "bg-white"
                                        }`}
                                >
                                    <div className="p-1">
                                        {/* <img
                      src={
                        plant.image
                          ? plant.image
                          : 'https://worldlex.net/assets/images/modules/cards/gcl.png'
                      }
                      // src="https://worldlex.net/assets/images/modules/cards/gcl.png"
                      className="img-responsive"
                      style={{ height: '30px' }}
                    /> */}
                                        <span className="ml-1 text-primary">{plant.name}</span>

                                        <span
                                            className="float-right pointer"
                                            onClick={() =>
                                                plant.isDisabled
                                                    ? undefined
                                                    : setFieldValue(
                                                        "deletePlants",
                                                        handleSelectDeletePlant(values.deletePlants, plant.hex),
                                                    )
                                            }
                                            title={
                                                plant.isDisabled
                                                    ? ReactDOMServer.renderToString(
                                                        <Translator
                                                            file="module-userManagement"
                                                            name="module.um.not-authorised-delete-plant"
                                                        />,
                                                    )
                                                    : ReactDOMServer.renderToString(
                                                        <Translator
                                                            file="module-userManagement"
                                                            name="module.um.delete"
                                                        />,
                                                    )
                                            }
                                        >
                                            <AppRemixIcon
                                                icon="delete-bin"
                                                color={plant.isDisabled ? colors.grey300 : colors.danger}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {module.plants?.length > 0 && (
                            <div className="p-2">
                                <div style={{ backgroundColor: "#fff3cd" }} className="text-primary">
                                    <div className="d-inline-flex align-items-center p-1">
                                        <AppCheckbox
                                            value={module.emailNotification}
                                            onChange={(v) =>
                                                _.map(values.modules, (m, i) =>
                                                    m.hex === module.hex
                                                        ? setFieldValue(`modules[${i}].emailNotification`, v)
                                                        : undefined,
                                                )
                                            }
                                            isDisabled={values?.editModules?.[module.hex]?.template}
                                        />

                                        <span className="ml-2">
                                            <Translator
                                                file="module-userManagement"
                                                name="module.um.notification-obligations-email"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

const PermissionTemplateWrapper = styled.div`
  margin-left: auto;
  margin-right: 20px;
  padding: 0 10px;
  min-width: 400px;
  background-color: white;
  color: #212529;
`;
